<template>
	<div class="flex flex-col gap-6">
		<h2 class="font-bold text-xl md:text-3xl">Poddar</h2>
		
		<nav class="my-3 my-6 flex flex-col md:flex-row justify-between md:items-center gap-8">
			<ul class="flex flex-row gap-3 text-xs md:text-base overflow-x-auto overflow-y-visable -my-4 py-4 whitespace-nowrap">
				<li>
					<router-link
						:to="{ name: 'PodcastsList' }"
						class="bg-transparent border border-white hover:bg-red hover:border-red text-white rounded-full p-2 px-4"
						:class="{ '!border-red !bg-red': ['PodcastsList', 'PodcastListLatest'].includes($route.name) }">Poddar</router-link>
				</li>
				<li>
					<router-link :to="{ name: 'PodcastsListFavourites' }" class="bg-transparent border border-white hover:bg-red hover:border-red text-white rounded-full p-2 px-4" exact-active-class="!border-red !bg-red">Mina favoriter</router-link>
				</li>
				<li>
					<router-link :to="{ name: 'PodcastsListContinues' }" class="bg-transparent border border-white hover:bg-red hover:border-red text-white rounded-full p-2 px-4" exact-active-class="!border-red !bg-red">Fortsätt lyssna</router-link>
				</li>
			</ul>
			<ul v-if="['default','latest'].includes(props.sort)" class="flex flex-row gap-3">
				<li>
					<router-link :to="{ name: 'PodcastsList' }" class="border-b border-white pb-1 text-white" exact-active-class="!border-red !text-red">A-Ö</router-link>
				</li>
				<li>
					<router-link :to="{ name: 'PodcastListLatest' }" class="border-b border-white pb-1 text-white" exact-active-class="!border-red !text-red">Senaste avsnitt</router-link>
				</li>
			</ul>
		</nav>
		
		<div v-if="props.sort===`continues`" class="flex flex-col gap-6 border-b border-white pb-9 mb-6">
			<ul class="grid grid-cols-1 md:grid-cols-2 gap-6">
				<li v-for="episode in continuePodcasts" :key="episode.linkid" class="flex flex-row gap-9 items-center">
					<EpisodeCard :episode="episode" play="true" />
				</li>
			</ul>
		</div>
		
		<div v-if="props.sort===`favourites`" class="flex flex-col gap-6">
			<ul v-if="favoritePodcasts.length > 0" class="grid grid-cols-1 md:grid-cols-3 gap-6 border-b border-white pb-9 mb-6">
				<li v-for="podcast in favoritePodcasts" :key="podcast.id">
					<PodcastCard :podcast="podcast" />
				</li>
			</ul>
			<p v-else>Du har inga favoriter.</p>
		</div>
		
		<div v-if="props.sort===`latest`" class="flex flex-col gap-6 border-b border-white pb-9 mb-6">
			<ul class="grid grid-cols-1 md:grid-cols-3 gap-6">
				<li v-for="podcast in store.podcasts" :key="podcast.id">
					<PodcastCard :podcast="podcast" />
				</li>
			</ul>
		</div>
		
		<div v-if="props.sort===`default`">
			<div v-for="(podcasts, letter) in groupedPodcasts" :key="letter" class="flex flex-col gap-6 border-b border-white pb-9 mb-6">
				<h2 class="text-2xl">
					{{ letter }}
				</h2>
				<ul class="grid grid-cols-1 md:grid-cols-3 gap-6">
					<li v-for="podcast in podcasts" :key="podcast.id">
						<PodcastCard :podcast="podcast" />
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { computed, defineProps } from 'vue'
	import { usePodcastStore } from '../stores/podcastStore'
	import PodcastCard from '@/components/PodcastCard.vue'
	import EpisodeCard from '@/components/EpisodeCard.vue'
	const store = usePodcastStore()
	
	const favoritePodcasts = computed(() => {
		return store.podcasts.filter(podcast => 
			store.favoritePodcastIds.includes(podcast.id)
		)
	})
	
	const props = defineProps({
		id: {
			type: String,
			required: true
		},
		sort: {
			type: String,
			default: 'default'
		}
	})
	
	const groupedPodcasts = computed(() => {
		const groups = {}
		const sortedPodcasts = [...store.podcasts].sort((a, b) => 
			a.name.localeCompare(b.name, 'sv')
		)
	
		sortedPodcasts.forEach(podcast => {
			if (!podcast.name) return
			
			const firstLetter = podcast.name.charAt(0).toUpperCase()
			
			if (!groups[firstLetter]) {
				groups[firstLetter] = []
			}
			groups[firstLetter].push(podcast)
		})
	
		return groups
	})
	
	const continuePodcasts = computed(() => {
		// 1. Hämta ut alla nycklar (ID:n) från objektet
		const validIds = Object.keys(store.playbackPositions).filter(id => id !== 'undefined')
		// 2. Filtrera din store så att bara poddar med matchande ID sparas
		return store.episodes.filter(episode => validIds.includes(episode.linkid))
	})

</script>